module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Bold-0b58ca4241eda42cff1f3195ef650db5.woff2";